module.exports = __webpack_public_path__ + "media/images/interested_events_header_line-c5b954d4.svg";